import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetReportBase64 } from '../ReportService/report.model';

import {
  ICancelVendaEstoqueBody,
  ICreateVendaEstoqueBody,
  IVendaEstoqueDto
} from './venda-estoque.model';

@Injectable({
  providedIn: 'root'
})
export class VendaEstoqueService {
  constructor(private http: HttpClient) {}

  CreateVendaEstoque(
    body: ICreateVendaEstoqueBody,
    guid: string
  ): Observable<IVendaEstoqueDto> {
    const headers = new HttpHeaders({ IdempotencyKey: guid });
    return this.http.post<IVendaEstoqueDto>(
      `${environment.baseURL}VendaEstoque/CreateVendaEstoque`,
      body,
      { headers }
    );
  }

  CancelVendaEstoque(
    id: number,
    body: Omit<ICancelVendaEstoqueBody, 'PK_VEND_ESTQ'>
  ): Observable<IVendaEstoqueDto> {
    return this.http.put<IVendaEstoqueDto>(
      `${environment.baseURL}VendaEstoque/CancelVendaEstoque?id=${id}`,
      { PK_VEND_ESTQ: id, ...body }
    );
  }

  /** FL_TIPO_DOCU: 0 = PDF, 1 = TXT (impressora térmica). */
  GetReceiptVendaEstoqueById(
    pkVendEstq: number,
    tipoDocumento: number = 0
  ): Observable<IGetReportBase64> {
    const params = new HttpParams()
      .set('PK_VEND_ESTQ', String(pkVendEstq))
      .set('FL_TIPO_DOCU', String(tipoDocumento));
    return this.http.get<IGetReportBase64>(
      `${environment.baseURL}VendaEstoque/GetReceiptVendaEstoqueById`,
      { params }
    );
  }
}
